import {
  TicketDetailsModel,
  TicketListItemModel,
} from "@jugl-web/rest-api/tickets/models";
import { TicketInboxFilter } from "@jugl-web/rest-api/tickets/models/common-types/TicketInboxFilter";
import isToday from "date-fns/isToday";

export interface DoesTicketMatchListCriteriaOptions {
  filter?: TicketInboxFilter;
  meId?: string;
  contactId?: string;
  searchQuery?: string;
}

/**
 * Returns whether a ticket belongs in a list described by the same criteria
 * as `useTicketList` / `buildGetTicketsQueryParams`.
 */
export const doesTicketMatchListCriteria = (
  ticket: TicketListItemModel | TicketDetailsModel,
  {
    filter,
    meId = "",
    contactId,
    searchQuery = "",
  }: DoesTicketMatchListCriteriaOptions
): boolean => {
  if (contactId && ticket.contact.id !== contactId) {
    return false;
  }

  const normalizedSearchQuery = searchQuery.trim().toLowerCase();

  if (normalizedSearchQuery) {
    const searchableText = [ticket.title, ticket.desc, ticket.unique_id]
      .join(" ")
      .toLowerCase();

    if (!searchableText.includes(normalizedSearchQuery)) {
      return false;
    }
  }

  if (!filter) {
    return true;
  }

  switch (filter) {
    case "all":
      return ticket.status !== "resolved";
    case "unassigned":
      return ticket.status !== "resolved" && ticket.assignees.length === 0;
    case "assigned_to_user":
      return (
        ticket.status !== "resolved" &&
        ticket.assignees.some((assignee) => assignee.user_id === meId)
      );
    case "todo-today":
      return (
        ticket.status !== "resolved" &&
        ticket.assignees.some((assignee) => assignee.user_id === meId) &&
        !!ticket.due_at &&
        isToday(new Date(ticket.due_at))
      );
    case "recents":
      return true;
    default:
      return ticket.status === filter;
  }
};
